/* eslint-disable @stylistic/max-len */

const orderEntryFields = [
  'basePrice(formattedValue)',
  'entryNumber',
  'product(code, onSale, newProduct, bestSeller, star, price(FULL), discountedPrice, recommendedPrice(FULL), commercialCode, primaryImages(FULL), name,url,externalLogistician, topCategoryName, subCategoryName, sisCategory, sisSubCategory, maxOrderQuantity,accessoryCategorisation,isAccessory,productGenre,packDepth,packHeight,packWidth,packVolume,familyAnneeN,family2)',
  'quantity',
  'totalPriceWithoutDiscounts(formattedValue,value)',
  'totalPrice(formattedValue,value)',
  'extendedWarrantyOffer(FULL)'
];

const promotionFields = [
  'promotion(FULL)',
  'promotionActions(amount(formattedValue,value),lostAmount(formattedValue,value),usedCouponCodes,usedCouponNames,cmsComponentsIDs)',
  'consumedEntries(orderEntryNumber)',
  'description'
];

export const cartFields = [
  `entryGroups(FULL,entries(${orderEntryFields.join(',')}))`,
  `appliedOrderPromotions(${promotionFields.join(',')})`,
  `appliedProductPromotions(${promotionFields.join(',')})`,
  'code',
  'deliveryCost(formattedValue,value)',
  'deliveryMode(code,type,deliveryProvider)',
  'entries',
  'guid',
  'potentialOrderPromotions(description,promotion)',
  'subTotalPriceWithProductDiscounts(formattedValue,value)',
  'totalDiscountsWithoutDeliveryCost(formattedValue,value)',
  'totalEcoTax(formattedValue)',
  'totalPrice(formattedValue,value,currencyIso)',
  'deliveryAddress(FULL)',
  'paymentAddress(FULL)',
  'paymentMode',
  'user(name,uid,encryptedEmail)',
  'isForfait',
  'serviceShippingIncluded',
  'freeShippingApplied',
  'depositWithdrawalAddress(FULL)',
  'orderType',
  'paymentCost(formattedValue,value)',
  'totalWeight',
  'longestProductLength',
  'longestProductWidth',
  'highestProduct',
  'heaviestProduct',
  'totalProducts',
  'relayPointAddress(FULL)',
  'isRelayPointUserInfoFilled',
  'extendedWarrantyOrder(FULL)'
];
